import Hero from "@/components/Hero";
import Services from "@/components/Services";
import CTA from "@/components/CTA";
import { SEO } from "@/components/shared";
import { DiscordWidgetCompact } from "@/components/DiscordWidget";

export default function HomePage() {
  return (
    <>
      <SEO
        title="Vexora Development — Minecraft Development & Technology Community"
        description="Professional Minecraft development, custom plugins, and innovative server solutions. Join the Vexora Development community and build beyond limits."
      />
      <Hero />
      <Services />
      <CTA />
      <section
        data-testid="home-widget-section"
        className="relative pb-20 border-t border-purple-500/10"
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <DiscordWidgetCompact />
        </div>
      </section>
    </>
  );
}
